/**
 * Predefined dateFormat tokens. Ideally, formats from the configuration should be used instead though,
 * as they can vary between countries.
 *
 * They are unicode tokens:
 *  - https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *  - https://date-fns.org/v2.29.1/docs/format
 */
export enum DateFormat {
    BUILD_DATE_FORMAT = 'ddMMyyyy-HHmm',
    BUILD_DATE_VIEW_FORMAT = 'dd-MMM HH:mm',

    ISO_DATE_FORMAT = 'yyyy-MM-dd',
    ISO_DATE_FORMAT_WITHOUT_DAY = 'yyyy-MM',
    ISO_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
    // used by API mostly - omits seconds
    API_DATE_WITH_OFFSET = "yyyy-MM-dd'T'HH:mm:ssXXX",
    // https://github.beeone.at/platform/groupapi-openapi-specification/blob/main/README.md#datatypedatetime-datetime
    GROUP_API_DATE_WITH_OFFSET = "yyyy-MM-dd'T'HH:mm:ssxxxx",
    ISO_DATE_TIME_FORMAT_WITHOUT_TIMEZONE = "yyyy-MM-dd'T'HH:mm",
    UTC_ISO_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'",
    DATE_TIME_WITHOUT_DELIMITERS = "yyyyMMdd'T'HHmmss",
    TIME_FULL = 'HH:mm:ss',

    TIME_SHORT = 'HH:mm',
    MONTH_SLASH_YEAR = 'MM / yyyy',

    YEAR_LONG = 'yyyy',
    YEAR_SHORT = 'yy',
    YEAR_SINGLE = 'Y',
    DATE_SINGLE = 'd',
    ISO_WEEKDAY = 'i',
    MONTH_NUMERIC = 'MM',
    MONTH_NUMBER_SHORT = 'M',
    MONTH_SHORT = 'MMM',
    MONTH_TEXT_SHORT = 'LLL',
    MONTH_TEXT_LONG = 'LLLL',
    YEAR_MONTH_WITHOUT_DELIMITER_SHORT = 'yyMM',
    YEAR_MONTH_WITHOUT_DELIMITER_LONG = 'yyyyMM',
    YEAR_MONTH_DAY_WITHOUT_DELIMITER_SHORT = 'yyMMdd',
    MONTH_TEXT_SHORT_YEAR = 'LLL yyyy',
    MONTH_TEXT_LONG_YEAR = 'LLLL yyyy',
    DAY_OF_MONTH_ORDINAL = 'do',
    DAY_OF_YEAR = 'D',
    DAY_OF_MONTH_ORDINAL_WITH_MONTH_WIDE = 'do MMMM',
    QUARTER = 'Q',
    HOUR_SINGLE = 'H',
    MINUTE_SINGLE = 'm',

    // local formats
    DATE_MONTH_YEAR_DOTS = 'dd.MM.yyyy',
    DATE_MONTH_YEAR_DOTS_SPACED = 'dd. MM. yyyy',
    DATE_MONTH_YEAR_DOTS_WITHOUT_ZEROES = 'd.M.yyyy',
    DATE_MONTH_DOTS = 'dd.MM.',
    DATE_MONTH_YEAR_DOTS_WITH_TIME = 'dd.MM.yyyy HH:mm',
    DATE_MONTH_YEAR_DOTS_WITH_TIME_FULL = 'dd.MM.yyyy HH:mm:ss',
    DATE_MONTH_YEAR_DASH = 'dd-MM-yyyy',
    DATE_MONTH_YEAR_SLASH = 'dd/MM/yyyy',
    DATE_MONTH_YEAR_SLASH_WITH_TIME = 'dd/MM/yyyy HH:mm',
    YEAR_MONTH_SHORT_DATE_DOTS = 'dd.M.yyyy',
    YEAR_MONTH_DATE_DOTS = 'yyyy.MM.dd',
    YEAR_MONTH_HOUR_NO_DELIM = 'yyyyMMddHH',
    SHORT_DAY_WITH_DATE_TIME_DOTS = 'EEE dd.MM.yyyy HH:mm',
    DATE_MONTH_TEXT_SHORT_DOTS = 'dd. MMM',
    SHORT_LOCALIZED_DATE = 'P',
    LONG_LOCALIZED_DATE = 'PPPP',
    LONG_LOCALIZED_DATE_WITH_TIME_SPACE = 'PPPP p',
    LONG_LOCALIZED_DATE_WITH_TIME = 'PPPp',
    DATE_LONG_MONTH = 'd MMM',
    MONTH_YEAR_LONG_SLASH = 'MM/yyyy',
    MONTH_YEAR_SHORT_SLASH = 'MM/yy',
    QUARTER_YEAR = 'QQQ/yyyy',
    QUARTER_YEAR_SHORT = 'QQQ/yy',
    FULL_YEAR_MONTH_DAY_WITHOUT_DELIMITER_SHORT = 'yyyyMMdd',
    DATE_WITH_TIME_ZONE = 'yyyy-MM-ddxxxx', // used by old AT endpoint. API change requested
    DAY_SLASH_MONTH_FORMAT = 'dd/MM',
    DATE_MONTH_VERBOSE = 'd. MMMM yyyy', // e.g. 5. června 2023 (used in CZ)
    DAY_MONTH_YEAR_WITHOUT_DELIMITER_SHORT = 'ddMMyy',
}
